import cn from 'classnames';
import { useState } from 'react';
import { createPortal } from 'react-dom';

import { IconFullscreen } from '@webapp/common/assets/icons/fullscreen';
import { HelpText } from '@webapp/common/components/help-text';
import { ImageSlider } from '@webapp/common/components/image-slider';
import { CDN_URL } from '@webapp/common/conf';

import css from './image-with-gallery.css';

export const ImageWithGallery: FC<{
    imageUrl: string;
    text?: string;
    textElem?: ReactNode;
    hideZoom?: boolean;
    openSliderOnImgClick?: boolean;
    alt?: string;
    className?: string;
    overflowByHeight?: boolean;
    onClickWrap?: () => void;
}> = ({ imageUrl, text, textElem, hideZoom, alt, className, onClickWrap, overflowByHeight, openSliderOnImgClick }) => {
    const [showSlider, setShowSlider] = useState(false);
    const fullImageUrl = `${CDN_URL}${imageUrl}`;

    const handleShowSlider = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        setShowSlider(true);
    };

    return (
        <>
            <div className={className} onClick={onClickWrap}>
                {textElem || (text && <HelpText className={css.helpText} value={text} />)}
                {imageUrl && (
                    <div className={cn(css.imageWrap, { [css.imageWrapWithText]: textElem || text })}>
                        <img
                            src={fullImageUrl}
                            alt={alt || 'image'}
                            onClick={openSliderOnImgClick && handleShowSlider}
                        />
                        {!hideZoom && <IconFullscreen className={css.zoomIcon} onClick={handleShowSlider} />}
                    </div>
                )}
            </div>
            {showSlider &&
                createPortal(
                    <ImageSlider
                        slides={[{ id: 1, img: { url: fullImageUrl } }]}
                        onClose={() => {
                            setShowSlider(false);
                        }}
                        overflowByHeight={overflowByHeight}
                    />,
                    document.body,
                )}
        </>
    );
};
